import { useState } from "react";
import {
  Box,
  Input,
  Button,
  VStack,
  useToast,
  HStack,
  Textarea,
  Select,
  Text,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import axios from "axios";
import { useSelector } from "react-redux";

const BASE_URL = "https://develop-project-360.onrender.com";

export const createProject = (data) =>
  axios.post(`${BASE_URL}/createProject`, data);

const ProjectForm = ({ onProjectCreated }) => {
  const adminId = useSelector((store) => store.authentication.users.id);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [priority, setPriority] = useState("Medium");
  const [status, setStatus] = useState("Active");

  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const resetForm = () => {
    setName("");
    setDescription("");
    setStartDate("");
    setEndDate("");
    setPriority("Medium");
    setStatus("Active");
    setShowDetailsForm(false);
  };

  const handleInitialSubmit = () => {
    if (!name.trim()) {
      toast({ title: "Project name is required", status: "warning" });
      return;
    }
    onOpen();
  };

  const handleFinalSubmit = async () => {
    try {
      const payload = {
        name,
        createdBy: adminId,
        description,
        startDate,
        endDate,
        priority,
        status,
      };
      const { data } = await createProject(payload);
      toast({
        title: "Project created successfully add phase and members",
        status: "success",
      });
      onProjectCreated(data.data);
      resetForm();
      onClose();
    } catch (err) {
      toast({ title: "Failed to create project", status: "error" });
    }
  };

  return (
    <Box p={1} borderWidth="1px" borderRadius="md" bg="white">
      <VStack spacing={2} align="stretch">
        {!showDetailsForm && (
          <HStack spacing={3}>
            <Input
              placeholder="Project Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <Button
              onClick={handleInitialSubmit}
              bgGradient="linear(to-r, green.300,  teal.100)"
              _hover={{ bgGradient: "linear(to-r, green.100,  green.400)" }}
              size={"sm"}
            >
              Create Project
            </Button>
          </HStack>
        )}

        {/* Modal: Ask to show more */}
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Add more details?</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text>
                Would you like to add more information like description, dates,
                priority, and status before submitting?
              </Text>
            </ModalBody>
            <ModalFooter>
              <Button
                variant="ghost"
                mr={3}
                onClick={() => {
                  setShowDetailsForm(true);
                  onClose();
                }}
              >
                Yes
              </Button>
              <Button
                bgGradient="linear(to-r, green.300, teal.100)"
                _hover={{ bgGradient: "linear(to-r, green.100, green.400)" }}
                onClick={handleFinalSubmit}
              >
                No, Submit Now
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Extended Form */}
        {showDetailsForm && (
          <Box borderWidth="1px" borderRadius="md" p={4}>
            <VStack spacing={4}>
              <FormControl>
                <FormLabel>Project Name</FormLabel>
                <Input value={name} onChange={(e) => setName(e.target.value)} />
              </FormControl>

              <FormControl>
                <FormLabel>Description</FormLabel>
                <Textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Project Description"
                />
              </FormControl>

              <HStack spacing={4} w="100%">
                <FormControl>
                  <FormLabel>Start Date</FormLabel>
                  <Input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>End Date</FormLabel>
                  <Input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </FormControl>
              </HStack>

              <HStack spacing={4} w="100%">
                <FormControl>
                  <FormLabel>Priority</FormLabel>
                  <Select
                    value={priority}
                    onChange={(e) => setPriority(e.target.value)}
                  >
                    <option value="Low">Low</option>
                    <option value="Medium">Medium</option>
                    <option value="High">High</option>
                  </Select>
                </FormControl>

                <FormControl>
                  <FormLabel>Status</FormLabel>
                  <Select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="Active">Active</option>
                    <option value="Completed">Completed</option>
                    <option value="On Hold">On Hold</option>
                    <option value="Cancelled">Cancelled</option>
                  </Select>
                </FormControl>
              </HStack>

              <Button
                onClick={handleFinalSubmit}
                width="full"
                bgGradient="linear(to-r, green.300, teal.100)"
                _hover={{ bgGradient: "linear(to-r, green.100, green.400)" }}
              >
                Submit Project
              </Button>
            </VStack>
          </Box>
        )}
      </VStack>
    </Box>
  );
};

export default ProjectForm;
